import { TooltipedTextComponent } from 'commons/components';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { sortAndJoin } from 'commons/utils/sort.utils';
import { useTranslation } from 'core/i18n/i18n';
import { OperatorCustomNotificationRow } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.model';

export interface OperatorCustomNotificationsConfirmationModalHeaderComponentProps {
    notifications: OperatorCustomNotificationRow[];
    headerText: string;
}

export const OperatorCustomNotificationsConfirmationModalHeaderComponent: React.FC<
    OperatorCustomNotificationsConfirmationModalHeaderComponentProps
> = ({ notifications, headerText }) => {
    const { t } = useTranslation();

    if (notifications.length === 1) {
        return (
            <PocTypography variant="button">{t(headerText, { name: notifications[0].notificationName })}</PocTypography>
        );
    }

    return (
        <TooltipedTextComponent
            i18nKey={headerText}
            tooltipText={sortAndJoin(notifications.map((notification) => notification.notificationName))}
            i18nValues={{ amount: notifications.length }}
            tooltipAnchorClassname="blue-tooltip-span"
            showTooltipAlways
        />
    );
};
